const createCron = async ({ params, api }) => {
  return await api('cron', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createCron;